import { BackendSearch } from '@shared/datastore/core';
import { SearchContestResultAjax } from './search-contests.backend-model';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    searchContests: SearchContestResultAjax;
  }
}

export const searchContestsBackend: BackendSearch = {
  fetch: q => ({
    endpoint: `search/contests.php`,
    isGaf: true,
    params: q,
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-contests/search-contests.backend.ts